/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ProtectedRouteRouteImport } from './routes/_protected/route'
import { Route as PublicRouteRouteImport } from './routes/_public/route'
import { Route as ProtectedIndexRouteImport } from './routes/_protected/index'
import { Route as ProtectedAdsRouteImport } from './routes/_protected/ads'
import { Route as ProtectedAssistantRouteImport } from './routes/_protected/assistant'
import { Route as ProtectedAwarenessRouteImport } from './routes/_protected/awareness'
import { Route as ProtectedBehaviorRouteImport } from './routes/_protected/behavior'
import { Route as ProtectedChannelsRouteImport } from './routes/_protected/channels'
import { Route as ProtectedCompetitorsRouteImport } from './routes/_protected/competitors'
import { Route as ProtectedCreativesRouteImport } from './routes/_protected/creatives'
import { Route as ProtectedDeploymentsRouteImport } from './routes/_protected/deployments'
import { Route as ProtectedFunnelRouteImport } from './routes/_protected/funnel'
import { Route as ProtectedGa4RouteImport } from './routes/_protected/ga4'
import { Route as ProtectedGlossaryRouteImport } from './routes/_protected/glossary'
import { Route as ProtectedGoalsRouteImport } from './routes/_protected/goals'
import { Route as ProtectedHealthRouteImport } from './routes/_protected/health'
import { Route as ProtectedMetaRouteImport } from './routes/_protected/meta'
import { Route as ProtectedOccupancyRouteImport } from './routes/_protected/occupancy'
import { Route as ProtectedPipedriveRouteImport } from './routes/_protected/pipedrive'
import { Route as ProtectedRedditRouteImport } from './routes/_protected/reddit'
import { Route as ProtectedSearchRouteImport } from './routes/_protected/search'
import { Route as ProtectedSegmentsRouteImport } from './routes/_protected/segments'
import { Route as ProtectedTimingRouteImport } from './routes/_protected/timing'
import { Route as PublicLoginRouteImport } from './routes/_public/login'

const ProtectedRouteRoute = ProtectedRouteRouteImport.update({
  id: '/_protected',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicRouteRoute = PublicRouteRouteImport.update({
  id: '/_public',
  getParentRoute: () => rootRouteImport,
} as any)
const ProtectedIndexRoute = ProtectedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ProtectedRouteRoute,
} as any)
const ProtectedAdsRoute = ProtectedAdsRouteImport.update({
  id: '/ads',
  path: '/ads',
  getParentRoute: () => ProtectedRouteRoute,
} as any)
const ProtectedAssistantRoute = ProtectedAssistantRouteImport.update({
  id: '/assistant',
  path: '/assistant',
  getParentRoute: () => ProtectedRouteRoute,
} as any)
const ProtectedAwarenessRoute = ProtectedAwarenessRouteImport.update({
  id: '/awareness',
  path: '/awareness',
  getParentRoute: () => ProtectedRouteRoute,
} as any)
const ProtectedBehaviorRoute = ProtectedBehaviorRouteImport.update({
  id: '/behavior',
  path: '/behavior',
  getParentRoute: () => ProtectedRouteRoute,
} as any)
const ProtectedChannelsRoute = ProtectedChannelsRouteImport.update({
  id: '/channels',
  path: '/channels',
  getParentRoute: () => ProtectedRouteRoute,
} as any)
const ProtectedCompetitorsRoute = ProtectedCompetitorsRouteImport.update({
  id: '/competitors',
  path: '/competitors',
  getParentRoute: () => ProtectedRouteRoute,
} as any)
const ProtectedCreativesRoute = ProtectedCreativesRouteImport.update({
  id: '/creatives',
  path: '/creatives',
  getParentRoute: () => ProtectedRouteRoute,
} as any)
const ProtectedDeploymentsRoute = ProtectedDeploymentsRouteImport.update({
  id: '/deployments',
  path: '/deployments',
  getParentRoute: () => ProtectedRouteRoute,
} as any)
const ProtectedFunnelRoute = ProtectedFunnelRouteImport.update({
  id: '/funnel',
  path: '/funnel',
  getParentRoute: () => ProtectedRouteRoute,
} as any)
const ProtectedGa4Route = ProtectedGa4RouteImport.update({
  id: '/ga4',
  path: '/ga4',
  getParentRoute: () => ProtectedRouteRoute,
} as any)
const ProtectedGlossaryRoute = ProtectedGlossaryRouteImport.update({
  id: '/glossary',
  path: '/glossary',
  getParentRoute: () => ProtectedRouteRoute,
} as any)
const ProtectedGoalsRoute = ProtectedGoalsRouteImport.update({
  id: '/goals',
  path: '/goals',
  getParentRoute: () => ProtectedRouteRoute,
} as any)
const ProtectedHealthRoute = ProtectedHealthRouteImport.update({
  id: '/health',
  path: '/health',
  getParentRoute: () => ProtectedRouteRoute,
} as any)
const ProtectedMetaRoute = ProtectedMetaRouteImport.update({
  id: '/meta',
  path: '/meta',
  getParentRoute: () => ProtectedRouteRoute,
} as any)
const ProtectedOccupancyRoute = ProtectedOccupancyRouteImport.update({
  id: '/occupancy',
  path: '/occupancy',
  getParentRoute: () => ProtectedRouteRoute,
} as any)
const ProtectedPipedriveRoute = ProtectedPipedriveRouteImport.update({
  id: '/pipedrive',
  path: '/pipedrive',
  getParentRoute: () => ProtectedRouteRoute,
} as any)
const ProtectedRedditRoute = ProtectedRedditRouteImport.update({
  id: '/reddit',
  path: '/reddit',
  getParentRoute: () => ProtectedRouteRoute,
} as any)
const ProtectedSearchRoute = ProtectedSearchRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => ProtectedRouteRoute,
} as any)
const ProtectedSegmentsRoute = ProtectedSegmentsRouteImport.update({
  id: '/segments',
  path: '/segments',
  getParentRoute: () => ProtectedRouteRoute,
} as any)
const ProtectedTimingRoute = ProtectedTimingRouteImport.update({
  id: '/timing',
  path: '/timing',
  getParentRoute: () => ProtectedRouteRoute,
} as any)
const PublicLoginRoute = PublicLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => PublicRouteRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof ProtectedIndexRoute
  '/ads': typeof ProtectedAdsRoute
  '/assistant': typeof ProtectedAssistantRoute
  '/awareness': typeof ProtectedAwarenessRoute
  '/behavior': typeof ProtectedBehaviorRoute
  '/channels': typeof ProtectedChannelsRoute
  '/competitors': typeof ProtectedCompetitorsRoute
  '/creatives': typeof ProtectedCreativesRoute
  '/deployments': typeof ProtectedDeploymentsRoute
  '/funnel': typeof ProtectedFunnelRoute
  '/ga4': typeof ProtectedGa4Route
  '/glossary': typeof ProtectedGlossaryRoute
  '/goals': typeof ProtectedGoalsRoute
  '/health': typeof ProtectedHealthRoute
  '/meta': typeof ProtectedMetaRoute
  '/occupancy': typeof ProtectedOccupancyRoute
  '/pipedrive': typeof ProtectedPipedriveRoute
  '/reddit': typeof ProtectedRedditRoute
  '/search': typeof ProtectedSearchRoute
  '/segments': typeof ProtectedSegmentsRoute
  '/timing': typeof ProtectedTimingRoute
  '/login': typeof PublicLoginRoute
}
export interface FileRoutesByTo {
  '/': typeof ProtectedIndexRoute
  '/ads': typeof ProtectedAdsRoute
  '/assistant': typeof ProtectedAssistantRoute
  '/awareness': typeof ProtectedAwarenessRoute
  '/behavior': typeof ProtectedBehaviorRoute
  '/channels': typeof ProtectedChannelsRoute
  '/competitors': typeof ProtectedCompetitorsRoute
  '/creatives': typeof ProtectedCreativesRoute
  '/deployments': typeof ProtectedDeploymentsRoute
  '/funnel': typeof ProtectedFunnelRoute
  '/ga4': typeof ProtectedGa4Route
  '/glossary': typeof ProtectedGlossaryRoute
  '/goals': typeof ProtectedGoalsRoute
  '/health': typeof ProtectedHealthRoute
  '/meta': typeof ProtectedMetaRoute
  '/occupancy': typeof ProtectedOccupancyRoute
  '/pipedrive': typeof ProtectedPipedriveRoute
  '/reddit': typeof ProtectedRedditRoute
  '/search': typeof ProtectedSearchRoute
  '/segments': typeof ProtectedSegmentsRoute
  '/timing': typeof ProtectedTimingRoute
  '/login': typeof PublicLoginRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_protected': typeof ProtectedRouteRouteWithChildren
  '/_public': typeof PublicRouteRouteWithChildren
  '/_protected/ads': typeof ProtectedAdsRoute
  '/_protected/assistant': typeof ProtectedAssistantRoute
  '/_protected/awareness': typeof ProtectedAwarenessRoute
  '/_protected/behavior': typeof ProtectedBehaviorRoute
  '/_protected/channels': typeof ProtectedChannelsRoute
  '/_protected/competitors': typeof ProtectedCompetitorsRoute
  '/_protected/creatives': typeof ProtectedCreativesRoute
  '/_protected/deployments': typeof ProtectedDeploymentsRoute
  '/_protected/funnel': typeof ProtectedFunnelRoute
  '/_protected/ga4': typeof ProtectedGa4Route
  '/_protected/glossary': typeof ProtectedGlossaryRoute
  '/_protected/goals': typeof ProtectedGoalsRoute
  '/_protected/health': typeof ProtectedHealthRoute
  '/_protected/meta': typeof ProtectedMetaRoute
  '/_protected/occupancy': typeof ProtectedOccupancyRoute
  '/_protected/pipedrive': typeof ProtectedPipedriveRoute
  '/_protected/reddit': typeof ProtectedRedditRoute
  '/_protected/search': typeof ProtectedSearchRoute
  '/_protected/segments': typeof ProtectedSegmentsRoute
  '/_protected/timing': typeof ProtectedTimingRoute
  '/_public/login': typeof PublicLoginRoute
  '/_protected/': typeof ProtectedIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/ads'
    | '/assistant'
    | '/awareness'
    | '/behavior'
    | '/channels'
    | '/competitors'
    | '/creatives'
    | '/deployments'
    | '/funnel'
    | '/ga4'
    | '/glossary'
    | '/goals'
    | '/health'
    | '/meta'
    | '/occupancy'
    | '/pipedrive'
    | '/reddit'
    | '/search'
    | '/segments'
    | '/timing'
    | '/login'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/ads'
    | '/assistant'
    | '/awareness'
    | '/behavior'
    | '/channels'
    | '/competitors'
    | '/creatives'
    | '/deployments'
    | '/funnel'
    | '/ga4'
    | '/glossary'
    | '/goals'
    | '/health'
    | '/meta'
    | '/occupancy'
    | '/pipedrive'
    | '/reddit'
    | '/search'
    | '/segments'
    | '/timing'
    | '/login'
  id:
    | '__root__'
    | '/_protected'
    | '/_public'
    | '/_protected/ads'
    | '/_protected/assistant'
    | '/_protected/awareness'
    | '/_protected/behavior'
    | '/_protected/channels'
    | '/_protected/competitors'
    | '/_protected/creatives'
    | '/_protected/deployments'
    | '/_protected/funnel'
    | '/_protected/ga4'
    | '/_protected/glossary'
    | '/_protected/goals'
    | '/_protected/health'
    | '/_protected/meta'
    | '/_protected/occupancy'
    | '/_protected/pipedrive'
    | '/_protected/reddit'
    | '/_protected/search'
    | '/_protected/segments'
    | '/_protected/timing'
    | '/_public/login'
    | '/_protected/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  ProtectedRouteRoute: typeof ProtectedRouteRouteWithChildren
  PublicRouteRoute: typeof PublicRouteRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_protected': {
      id: '/_protected'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof ProtectedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public': {
      id: '/_public'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof PublicRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_protected/': {
      id: '/_protected/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof ProtectedIndexRouteImport
      parentRoute: typeof ProtectedRouteRoute
    }
    '/_protected/ads': {
      id: '/_protected/ads'
      path: '/ads'
      fullPath: '/ads'
      preLoaderRoute: typeof ProtectedAdsRouteImport
      parentRoute: typeof ProtectedRouteRoute
    }
    '/_protected/assistant': {
      id: '/_protected/assistant'
      path: '/assistant'
      fullPath: '/assistant'
      preLoaderRoute: typeof ProtectedAssistantRouteImport
      parentRoute: typeof ProtectedRouteRoute
    }
    '/_protected/awareness': {
      id: '/_protected/awareness'
      path: '/awareness'
      fullPath: '/awareness'
      preLoaderRoute: typeof ProtectedAwarenessRouteImport
      parentRoute: typeof ProtectedRouteRoute
    }
    '/_protected/behavior': {
      id: '/_protected/behavior'
      path: '/behavior'
      fullPath: '/behavior'
      preLoaderRoute: typeof ProtectedBehaviorRouteImport
      parentRoute: typeof ProtectedRouteRoute
    }
    '/_protected/channels': {
      id: '/_protected/channels'
      path: '/channels'
      fullPath: '/channels'
      preLoaderRoute: typeof ProtectedChannelsRouteImport
      parentRoute: typeof ProtectedRouteRoute
    }
    '/_protected/competitors': {
      id: '/_protected/competitors'
      path: '/competitors'
      fullPath: '/competitors'
      preLoaderRoute: typeof ProtectedCompetitorsRouteImport
      parentRoute: typeof ProtectedRouteRoute
    }
    '/_protected/creatives': {
      id: '/_protected/creatives'
      path: '/creatives'
      fullPath: '/creatives'
      preLoaderRoute: typeof ProtectedCreativesRouteImport
      parentRoute: typeof ProtectedRouteRoute
    }
    '/_protected/deployments': {
      id: '/_protected/deployments'
      path: '/deployments'
      fullPath: '/deployments'
      preLoaderRoute: typeof ProtectedDeploymentsRouteImport
      parentRoute: typeof ProtectedRouteRoute
    }
    '/_protected/funnel': {
      id: '/_protected/funnel'
      path: '/funnel'
      fullPath: '/funnel'
      preLoaderRoute: typeof ProtectedFunnelRouteImport
      parentRoute: typeof ProtectedRouteRoute
    }
    '/_protected/ga4': {
      id: '/_protected/ga4'
      path: '/ga4'
      fullPath: '/ga4'
      preLoaderRoute: typeof ProtectedGa4RouteImport
      parentRoute: typeof ProtectedRouteRoute
    }
    '/_protected/glossary': {
      id: '/_protected/glossary'
      path: '/glossary'
      fullPath: '/glossary'
      preLoaderRoute: typeof ProtectedGlossaryRouteImport
      parentRoute: typeof ProtectedRouteRoute
    }
    '/_protected/goals': {
      id: '/_protected/goals'
      path: '/goals'
      fullPath: '/goals'
      preLoaderRoute: typeof ProtectedGoalsRouteImport
      parentRoute: typeof ProtectedRouteRoute
    }
    '/_protected/health': {
      id: '/_protected/health'
      path: '/health'
      fullPath: '/health'
      preLoaderRoute: typeof ProtectedHealthRouteImport
      parentRoute: typeof ProtectedRouteRoute
    }
    '/_protected/meta': {
      id: '/_protected/meta'
      path: '/meta'
      fullPath: '/meta'
      preLoaderRoute: typeof ProtectedMetaRouteImport
      parentRoute: typeof ProtectedRouteRoute
    }
    '/_protected/occupancy': {
      id: '/_protected/occupancy'
      path: '/occupancy'
      fullPath: '/occupancy'
      preLoaderRoute: typeof ProtectedOccupancyRouteImport
      parentRoute: typeof ProtectedRouteRoute
    }
    '/_protected/pipedrive': {
      id: '/_protected/pipedrive'
      path: '/pipedrive'
      fullPath: '/pipedrive'
      preLoaderRoute: typeof ProtectedPipedriveRouteImport
      parentRoute: typeof ProtectedRouteRoute
    }
    '/_protected/reddit': {
      id: '/_protected/reddit'
      path: '/reddit'
      fullPath: '/reddit'
      preLoaderRoute: typeof ProtectedRedditRouteImport
      parentRoute: typeof ProtectedRouteRoute
    }
    '/_protected/search': {
      id: '/_protected/search'
      path: '/search'
      fullPath: '/search'
      preLoaderRoute: typeof ProtectedSearchRouteImport
      parentRoute: typeof ProtectedRouteRoute
    }
    '/_protected/segments': {
      id: '/_protected/segments'
      path: '/segments'
      fullPath: '/segments'
      preLoaderRoute: typeof ProtectedSegmentsRouteImport
      parentRoute: typeof ProtectedRouteRoute
    }
    '/_protected/timing': {
      id: '/_protected/timing'
      path: '/timing'
      fullPath: '/timing'
      preLoaderRoute: typeof ProtectedTimingRouteImport
      parentRoute: typeof ProtectedRouteRoute
    }
    '/_public/login': {
      id: '/_public/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof PublicLoginRouteImport
      parentRoute: typeof PublicRouteRoute
    }
  }
}

interface ProtectedRouteRouteChildren {
  ProtectedAdsRoute: typeof ProtectedAdsRoute
  ProtectedAssistantRoute: typeof ProtectedAssistantRoute
  ProtectedAwarenessRoute: typeof ProtectedAwarenessRoute
  ProtectedBehaviorRoute: typeof ProtectedBehaviorRoute
  ProtectedChannelsRoute: typeof ProtectedChannelsRoute
  ProtectedCompetitorsRoute: typeof ProtectedCompetitorsRoute
  ProtectedCreativesRoute: typeof ProtectedCreativesRoute
  ProtectedDeploymentsRoute: typeof ProtectedDeploymentsRoute
  ProtectedFunnelRoute: typeof ProtectedFunnelRoute
  ProtectedGa4Route: typeof ProtectedGa4Route
  ProtectedGlossaryRoute: typeof ProtectedGlossaryRoute
  ProtectedGoalsRoute: typeof ProtectedGoalsRoute
  ProtectedHealthRoute: typeof ProtectedHealthRoute
  ProtectedMetaRoute: typeof ProtectedMetaRoute
  ProtectedOccupancyRoute: typeof ProtectedOccupancyRoute
  ProtectedPipedriveRoute: typeof ProtectedPipedriveRoute
  ProtectedRedditRoute: typeof ProtectedRedditRoute
  ProtectedSearchRoute: typeof ProtectedSearchRoute
  ProtectedSegmentsRoute: typeof ProtectedSegmentsRoute
  ProtectedTimingRoute: typeof ProtectedTimingRoute
  ProtectedIndexRoute: typeof ProtectedIndexRoute
}

const ProtectedRouteRouteChildren: ProtectedRouteRouteChildren = {
  ProtectedAdsRoute: ProtectedAdsRoute,
  ProtectedAssistantRoute: ProtectedAssistantRoute,
  ProtectedAwarenessRoute: ProtectedAwarenessRoute,
  ProtectedBehaviorRoute: ProtectedBehaviorRoute,
  ProtectedChannelsRoute: ProtectedChannelsRoute,
  ProtectedCompetitorsRoute: ProtectedCompetitorsRoute,
  ProtectedCreativesRoute: ProtectedCreativesRoute,
  ProtectedDeploymentsRoute: ProtectedDeploymentsRoute,
  ProtectedFunnelRoute: ProtectedFunnelRoute,
  ProtectedGa4Route: ProtectedGa4Route,
  ProtectedGlossaryRoute: ProtectedGlossaryRoute,
  ProtectedGoalsRoute: ProtectedGoalsRoute,
  ProtectedHealthRoute: ProtectedHealthRoute,
  ProtectedMetaRoute: ProtectedMetaRoute,
  ProtectedOccupancyRoute: ProtectedOccupancyRoute,
  ProtectedPipedriveRoute: ProtectedPipedriveRoute,
  ProtectedRedditRoute: ProtectedRedditRoute,
  ProtectedSearchRoute: ProtectedSearchRoute,
  ProtectedSegmentsRoute: ProtectedSegmentsRoute,
  ProtectedTimingRoute: ProtectedTimingRoute,
  ProtectedIndexRoute: ProtectedIndexRoute,
}

const ProtectedRouteRouteWithChildren = ProtectedRouteRoute._addFileChildren(
  ProtectedRouteRouteChildren,
)

interface PublicRouteRouteChildren {
  PublicLoginRoute: typeof PublicLoginRoute
}

const PublicRouteRouteChildren: PublicRouteRouteChildren = {
  PublicLoginRoute: PublicLoginRoute,
}

const PublicRouteRouteWithChildren = PublicRouteRoute._addFileChildren(
  PublicRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  ProtectedRouteRoute: ProtectedRouteRouteWithChildren,
  PublicRouteRoute: PublicRouteRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
